import { Component } from '@angular/core';

/**
 * Renders a mail in the mailbox
 */
@Component({
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.scss'],
})
export class MailComponent {
  nyanCat = require('../../../../assets/demo/Nyan_cat_250px_frame.jpg');
}



// WEBPACK FOOTER //
// ./src/app/mailbox/mail/mail.component.ts